import { Component, Inject, OnInit, Optional } from '@angular/core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { DomainContext, IContextService, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { TradeRestrictonsPopupComponent } from './trade-restrictions-popup.component';
import { AWRContextService, AWRContextUtils, AwrDomainContext } from '@pershing/nxi-core';


@Component({
    selector: 'maprogram-details',
    templateUrl: './maprogram-details.component.html'
})

export class MaprogramDetailsComponent implements OnInit {
    inputValue = '';
    subs: Subscription;
    acctRef: any;
    programName = '';
    ManagerandModelName = '';
    tradeRestrictions = [];
    tradeRestrictionstotal = '';
    isHiddenMMName = true;
    isHiddenProgramInfo = true;
    isMAInfoFeatureEnabled = false;
    isMAInfoForWealthViewEnabled = false;
    constructor(
        private contextService: IContextService, private awrContextService: AWRContextService,
        private dialog: MatDialog,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        if (appSettings.ibdConfigMap.isMAInfoFeatureEnabled) {
            this.isMAInfoFeatureEnabled = true;
        }
        if (appSettings.ibdConfigMap.isMAInfoForWealthViewEnabled) {
            this.isMAInfoForWealthViewEnabled = true;
        }
    }
    ngOnInit(): void {
            if ((window.location.href).includes('portfolioplus')) {
                if (this.isMAInfoForWealthViewEnabled) {
                    this.subs = this.awrContextService.selectedAwrDomainContext$.subscribe((awrDomainContext: AwrDomainContext<any>) => {
                        const contextValue = AWRContextUtils.getContextFromDomainValue(awrDomainContext);
                        this.acctRef = contextValue.accountNumber;
                        this.getMAProgramInfo();
                    });
                }
            } else if (this.isMAInfoFeatureEnabled) {
                this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
                    const contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
                    this.inputValue = contextValue.inputValue;
                    this.acctRef = contextValue.hashValue;
                    this.getMAProgramInfo();
                });
            }
    }
    getMAProgramInfo() {
        if (this.acctRef !== '') {
            if ((window.location.href).includes('portfolioplus')) {
                this.nxiRestService.getNxiAWRPortfolioRestResponse(this.acctRef, 'getNXIMAProgramInfoAWR').subscribe((data) => {
                    if (data != null) {
                        console.log('Retrived common REST Balances params');
                        this.programName = data.programName;
                        this.ManagerandModelName = data.managerName + '-' + data.modelName;
                        this.tradeRestrictions = data.tradeRestrictions;
                        this.tradeRestrictionstotal = data.tradeRestrictions != null && data.tradeRestrictions.length > 0 ?
                        this.tradeRestrictions.toString() : null;
                    } else {
                        this.resetProgramInfo();
                    }
                    }, error => {
                        this.resetProgramInfo();
                    });
            } else {
                this.nxiRestService.getNxiPortfolioRestResponse(this.acctRef, 'getNXIMAProgramInfo').subscribe((data) => {
                    if (data != null) {
                        console.log('Retrived common REST Balances params');
                        this.programName = data.programName;
                        this.ManagerandModelName = data.managerName + '-' + data.modelName;
                        this.tradeRestrictions = data.tradeRestrictions;
                        this.tradeRestrictionstotal = data.tradeRestrictions != null && data.tradeRestrictions.length > 0 ?
                        this.tradeRestrictions.toString() : null;
                    } else {
                        this.resetProgramInfo();
                    }
                    }, error => {
                        this.resetProgramInfo();
                    });
            }
            }
    }
    resetProgramInfo() {
        this.programName = null;
        this.ManagerandModelName = null;
        this.tradeRestrictions = null;
        this.tradeRestrictionstotal = null;
    }
    onMouseOverEvent(content: string) {
        if (content.length > 34) {
            if (content === this.programName) {
                this.isHiddenProgramInfo = false;
            } else {
                this.isHiddenMMName = false;
            }
        }
    }
    onMouseLeaveEvent() {
        this.isHiddenMMName = true;
        this.isHiddenProgramInfo = true;
    }
    openRestrictionDialog() {
        this.dialog.open(TradeRestrictonsPopupComponent, { disableClose: true, data: { datakey1: this.tradeRestrictions } });
    }
}
